import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';

import type { MeanTableItems, Ptop2TableItems } from 'src/types/dashboard';
import { STACKED_BAR_WIDGET_TEST_ID } from 'src/components/dashboard/DashboardPage/widgets/StackedBarWidget/index';

import { styles } from './index.styles';

const NumbersHeader: FC<{
  comparisonDataName?: string;
  tableContent?: Ptop2TableItems | MeanTableItems | never[];
}> = ({ comparisonDataName = '', tableContent }) => {
  const { t } = useTranslation('dashboard');
  return (
    <Grid
      className="StackedBarWidget-numbersHeader"
      container
      item
      xs={12}
      lg={3}
      spacing={2}
      data-test-id={STACKED_BAR_WIDGET_TEST_ID}
    >
      <Grid
        item
        xs={4}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        <Typography sx={styles.numbersHeaderLabel} variant="button2">
          {tableContent?.[0]?.serieslabel ?? t('Labels.FavPercentage')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        <Typography sx={styles.numbersHeaderLabel}>
          {tableContent?.[1]?.serieslabel ?? t('Labels.DiffToLastYear')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        <Typography sx={styles.numbersHeaderLabel}>
          {comparisonDataName}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default NumbersHeader;
